import * as angular from 'angular';
import { RetailerServiceBase } from '../../../app.retailer.common/modules/services/retailer.service';

export class RetailerService extends RetailerServiceBase {
    public static $inject = ['retailerServiceUrl', 'siteAddressUrl', 'jispPayServiceUrl', 'apiCDNUrlRetailer'];

    constructor(
        retailerServiceUrl: string,
        siteAddressUrl: string,
        private jispPayServiceUrl: string,
        apiCDNUrlRetailer: string
    ) {
        super(retailerServiceUrl, siteAddressUrl, apiCDNUrlRetailer);
    }

    public checkStickersAvailable() {
        return this.getUrl('Products/CheckStickersAvailable');
    }

    public checkCanEditStickers() {
        return this.getUrl('NfcStickers/CheckCanEditStickers');
    }

    public activeStickers() {
        return this.getUrl('NfcStickers/Active');
    }

    public deletedStickers() {
        return this.getUrl('NfcStickers/Deleted');
    }

    public deleteSticker() {
        return this.getUrl('NfcStickers');
    }

    public freeStickersCount() {
        return this.getUrl('NfcStickers/FreeStickers');
    }

    public exportCSV() {
        return this.getUrl('NfcStickers/Export');
    }

    public getOperations() {
        return this.getUrl('NfcStickers/Operations');
    }

    public createOperation() {
        return this.getUrl('NfcStickers/Operations');
    }

    public validateProductsAndCategories() {
        return this.getUrl('NfcStickers/ValidateProductsAndCategories');
    }

    public validatePlaces() {
        return this.getUrl('NfcStickers/ValidatePlaces');
    }

    public restoreSticker() {
        return this.getUrl('NfcStickers/Restore');
    }

    public getCategoriesWithItemTypes() {
        return `${this.retailerServiceUrl}products/CategoriesWithItemTypes`;
    }

    public getClassificationDictionary() {
        return `${this.retailerServiceUrl}products/CategoriesWithItemTypesAndMeasurementses`;
    }

    public getOperationUrl(id: string) {
        return `${this.getOperationListUrl()}/${encodeURIComponent(id)}`;
    }

    public getOperationListUrl() {
        return this.retailerServiceUrl + 'operations';
    }

    public getImportFileUrl(replace: boolean) {
        return this.retailerServiceUrl + 'products/import?replaceExisting=' + (replace ? 'true' : 'false');
    }

    public getSignalREndpoint() {
        return this.retailerServiceUrl + 'signalr/v1.0';
    }

    public viewedPrivacyNotification() {
        return this.getUrl('profile/viewedPrivacyNotification');
    }

    public profile() {
        return this.getUrl('profile');
    }

    public languages() {
        return this.getUrl('Languages');
    }

    public profileEmail() {
        return this.getUrl('profile/email');
    }

    public profilePassword() {
        return this.getUrl('profile/password');
    }

    public emailExist(email: string) {
        return this.getUrl('account/emailExist?email=' + encodeURIComponent(email));
    }

    public forgotPassword() {
        return this.getUrl('account/forgotpassword');
    }

    public resetPassword() {
        return this.getUrl('account/resetpassword');
    }

    public loggedInAsAdmin() {
        return this.getUrl('account/adminpermission');
    }

    public stores() {
        return this.getUrl('stores');
    }

    public findStores() {
        return this.getUrl('stores/find');
    }

    public fetchAllPlaces() {
        return this.getUrl('stores/fetchAll');
    }

    public storesForFilter() {
        return this.getUrl('stores/forFilter');
    }

    public storesForRules() {
        return this.getUrl('stores/forRules');
    }

    public store(id?: number) {
        if (id) {
            return this.getUrl('stores/' + id);
        } else {
            return this.getUrl('stores');
        }
    }

    public archiveStore(id: number) {
        return this.getUrl('stores/' + id + '/archive');
    }

    public restoreStore(id: number) {
        return this.getUrl('stores/' + id + '/restore');
    }

    public storeExist(name: string) {
        return this.getUrl('stores/shopexist/' + encodeURIComponent(name));
    }

    public storeBusinessTypes() {
        return this.getUrl('stores/businessTypes');
    }

    public getStoreCoverUrl(id: number, width?: number, height?: number) {
        if (width && height) {
            return this.getUrl('stores/cover/' + id + '?width=' + width + '&height=' + height);
        } else {
            return this.getUrl('stores/cover/' + id);
        }
    }

    public getStoreLogoUrl(id: number, width?: number, height?: number) {
        if (width && height) {
            return this.getCDNUrl('stores/logo/' + id + '?width=' + width + '&height=' + height);
        } else {
            return this.getCDNUrl('stores/logo/' + id);
        }
    }

    public storeCover(id: number) {
        return this.getUrl('stores/' + id + '/cover');
    }

    public storeLogo(id: number) {
        return this.getUrl('stores/' + id + '/logo');
    }

    public jisppayPlaces(offset?: number, limit?: number) {
        if (offset == null) {
            offset = 0;
        }
        if (limit == null) {
            return this.getUrl(`jisppayPlaces?offset=${offset}`);
        } else {
            return this.getUrl(`jisppayPlaces?offset=${offset}&limit=${limit}`);
        }
    }

    public jisppayPlace(id: number) {
        return this.getUrl(`jisppayPlaces/${id}`);
    }

    public jisppayPlacesAny() {
        return this.getUrl('jisppayPlaces/any');
    }

    public jispPayEnable() {
        return this.getUrl(`jisppayPlaces/enable`);
    }

    public jispPayMerchants() {
        return this.getUrl('jisppayPlaces/merchants');
    }
    public jispPayDefaultMerchants() {
        return this.getUrl(`jisppayPlaces/defaultMerchants`);
    }
    public jisppayStaff() {
        return this.getUrl('jisppayStaff');
    }

    public jisppayShopper() {
        return `${this.jispPayServiceUrl}shopper`;
    }

    public retailerShopper() {
        return `${this.retailerServiceUrl}shoppers`;
    }

    public jisppayUploadAvatar() {
        return `${this.jisppayStaff()}/uploadAvatar`;
    }

    public jisppayAccount(id?: number) {
        if (id) {
            return this.getUrl(`jisppayStaff/${id}`);
        }
        return this.getUrl('jisppayStaff');
    }

    public jisppayAccountRestore() {
        return this.getUrl('jisppayStaff/restore');
    }

    public jisppayStaffAny(isActive?: boolean | string) {
        isActive = isActive === undefined || isActive === null ? true : isActive;
        return this.getUrl(`jisppayStaff/${encodeURIComponent(isActive as string)}/any`);
    }

    public storesForJispPay() {
        return this.getUrl('stores/forJisppay');
    }

    public storesForManager() {
        return this.getUrl('stores/forManager');
    }

    public jisppayStaffLoginExist(email: string) {
        return this.getUrl(`jisppayStaff/LoginExist?login=${encodeURIComponent(email)}`);
    }

    public openingHours(id: number) {
        return this.getUrl(`stores/${id}/openingHours`);
    }

    public storeCampaigns(id: number) {
        return this.getUrl(`stores/${id}/campaigns`);
    }

    public storeCampaignAnalytics(id: number) {
        return this.getUrl(`stores/${id}/campaignAnalytics`);
    }

    public storeImpressionAnalytics(id: number) {
        return this.getUrl(`stores/${id}/impressionAnalytics`);
    }

    public storeVisitsAnalytics(id: number) {
        return this.getUrl(`stores/${id}/visitsAnalytics`);
    }

    public campaignAnalytics(id: number) {
        return this.getUrl(`campaigns/${id}/analytics`);
    }

    public retailerCampaigns(offset: number, limit: number, sorting: any) {
        let column = '';
        let order = '';
        for (const c in sorting) {
            if (sorting.hasOwnProperty(c)) {
                column = c;
                order = sorting[c];
            }
        }
        return this.getUrl(`campaigns/retailers?offset=${offset}&limit=${limit}&SortOrder=${order}&SortColumn=${column}`);
    }

    public retailerCampaign(id: number) {
        return this.getUrl(`campaigns/retailers/${id}`);
    }

    public campaign(id?: number) {
        if (id) {
            return this.getUrl(`campaigns/${id}`);
        } else {
            return this.getUrl('campaigns');
        }
    }

    public campaignImage() {
        return this.getUrl('campaigns/image');
    }

    public campaignVideo() {
        return this.getUrl('campaigns/video');
    }

    public campaignVideoDelete(id: number) {
        return this.getUrl(`campaigns/video/${id}`);
    }

    public campaignVideoGet(id: number) {
        return this.getUrl(`campaigns/video/${id}`);
    }

    public campaignState(id: number) {
        return this.getUrl(`campaigns/${id}/state`);
    }

    public brands() {
        return this.getUrl('brands');
    }

    public brandsInventory() {
        return this.getUrl('brands/inventory');
    }

    public brandsClassification() {
        return this.getUrl('brands/classification');
    }

    public brandsSiblingCategories(id: number, level: number) {
        return this.getUrl(`brands/${id}/sibling/${level}`);
    }

    public dictionaryBrands() {
        return this.getUrl('brands/dictionary');
    }

    public approvedBrands() {
        return this.getUrl('brands/approved');
    }

    public inventory(shopID: number) {
        return this.getUrl(`stores/${shopID}/inventory`);
    }

    public classificationCategories() {
        return this.getUrl('classificationcategories');
    }

    public classificationCategoriesForRules() {
        return this.getUrl('classificationcategories/forRules');
    }

    public classificationCategoriesForRetailer() {
        return this.getUrl('classificationcategories/forRetailer');
    }

    public paymentCards() {
        return this.getUrl('billing/cards');
    }

    public paymentCard(id: number) {
        return this.getUrl('billing/cards/' + id);
    }

    public setDefaultPaymentCard(id: number) {
        return this.getUrl(`billing/cards/${id}/setDefault`);
    }

    public billingStatements() {
        return this.getUrl('billing/statements');
    }

    public billingStatementsExist() {
        return this.getUrl('billing/statements/exist');
    }

    public invoices() {
        return this.getUrl('billing/invoices');
    }

    public withdrawalPayPalAccount() {
        return this.getUrl('withdrawalPayPalAccount');
    }

    public profileUpdateShowGetStarted(show: boolean) {
        return this.getUrl('profile/' + encodeURIComponent(show.toString()) + '/getStarted');
    }

    public designRequest(sessionID?: number) {
        if (sessionID) {
            return this.getUrl('designRequest/' + sessionID);
        } else {
            return this.getUrl('designRequest');
        }
    }

    public designRequestFile(sessionID: number | string) {
        return this.getUrl(`designRequest/${sessionID}/file`);
    }

    public getProducts() {
        return this.getUrl('products');
    }

    public findProducts() {
        return this.getUrl('products/find');
    }

    public fetchProducts() {
        return this.getUrl('products/fetch');
    }

    public fetchAllProducts() {
        return this.getUrl('products/fetchAll');
    }

    public variationImage(id?: string) {
        if (id) {
            return this.getCDNUrl('products/image/' + id);
        } else {
            return this.getCDNUrl('products/image');
        }
    }

    public variationImageCopy() {
        return this.getUrl('products/image/copy');
    }

    public getProductImageUrl(id: string, width?: number, height?: number) {
        if (width && height) {
            return this.getCDNUrl('products/image/' + id + '?width=' + width + '&height=' + height);
        } else {
            if (height) {
                return this.getCDNUrl('products/image/' + id + '?height=' + height);
            } else {
                return this.getCDNUrl('products/image/' + id);
            }
        }
    }

    public attachment(id?: string) {
        if (id) {
            return this.getUrl(`Products/Attachment/${id}`);
        } else {
            return this.getUrl('Products/Attachment');
        }
    }

    public product(id?: string) {
        if (id) {
            return this.getUrl('products/' + id);
        } else {
            return this.getUrl('products');
        }
    }

    public exportCsvProduct() {
        return this.getUrl('/Products/Export');
    }

    public productPrice(id: string) {
        return this.getUrl(`products/${id}/price`);
    }

    public productPriceWithVat(id: string) {
        return this.getUrl(`Products/${id}/PriceWithVat`);
    }

    public productDiscount(id: string) {
        return this.getUrl(`Products/${id}/Discount`);
    }

    public productStockQuantity(id: string) {
        return this.getUrl(`Products/${id}/StockQuantity`);
    }

    public productLinkTypes() {
        return this.getUrl('products/linkTypes');
    }

    public archiveProduct(id: string) {
        return this.getUrl(`products/${id}/archive`);
    }

    public restoreProduct(productID: string, variationID?: string) {
        if (variationID) {
            return this.getUrl(`products/${productID}/restore/${variationID}`);
        } else {
            return this.getUrl(`products/${productID}/restore`);
        }
    }

    public existProducts(state: number) {
        return this.getUrl(`products/${state}/exist`);
    }

    public productVariationTwins(productID: string, variationID: string) {
        return this.getUrl(`products/${productID}/twins/${variationID}`);
    }

    public productItemTypes(categoryID: number | string, gender: number | string) {
        return this.getUrl(`products/itemTypes/${categoryID}?Gender=${gender || ''}`);
    }

    public getMenus(isArchived: boolean) {
        return this.getUrl(`menu?settings.isArchived=${isArchived.toString()}`);
    }

    public createMenu() {
        return this.getUrl('menu');
    }

    public getMenu(ID: string) {
        return this.getUrl(`menu/${ID}`);
    }

    public createMenuImage() {
        return this.getUrl('menu/image');
    }

    public getMenuImage(imageId: string, width?: number, height?: number) {
        return this.getCDNUrl(`menu/image/${imageId}?thumbnail.width=${width ? width : ''}&thumbnail.height=${(height ? height : '')}`);
    }

    public setEnabledMenu(ID: string, value: boolean) {
        return this.getUrl(`menu/${ID}/${ value ? 'enable' : 'disable' }`);
    }

    public setArchivedMenu(ID: string, value: boolean) {
        return this.getUrl(`menu/${ID}/${ value ? 'archive' : 'restore' }`);
    }

    // extras
    public activeExtras(): string {
        return this.getUrl('extras/active');
    }

    public extras(id?: string): string {
        return id ? this.getUrl(`extras/${id}`) : this.getUrl('extras');
    }

    public archiveExtra(id: number): string {
        return this.getUrl(`extras/${id}/archive`);
    }

    public restoreExtra(id: number): string {
        return this.getUrl(`extras/${id}/restore`);
    }

    public uploadExtraImage(): string {
        return this.getUrl('extras/image');
    }

    public createExtraImage() {
        return this.getUrl('extras/image');
    }

    public getExtraImage(id: string): string {
        return this.getCDNUrl(`extras/image/${id}`);
    }

    public checkTitle(title: string, extraID?: string): string {
        if (extraID) {
            return this.getUrl('extras/checkTitle?title=' + title + '&extraID=' + extraID);
        } else {
            return this.getUrl('extras/checkTitle?title=' + title);
        }
    }

    public referralAccounts(shopperID?: number) {
        return this.getUrl('referralAccounts/' + (shopperID || ''));
    }

    public shopperByReferralCode() {
        return this.getUrl('referralAccounts/shopperByCode');
    }

    public measurements(gender: number | string) {
        if (!gender) {
            gender = '';
        }
        return this.getUrl('measurements/regular?Gender=' + gender);
    }

    public smlMeasurements(gender: number | string) {
        if (!gender) {
            gender = '';
        }
        return this.getUrl('measurements/sml?Gender=' + gender);
    }

    public storeManagers() {
        return this.getUrl('storeManagers');
    }

    public storeManagerAny(isActive: boolean | string) {
        isActive = isActive === undefined ? true : isActive;
        return this.getUrl(`storeManagers/${encodeURIComponent(isActive as string)}/any`);
    }

    public storeManagerAccount(id?: number) {
        if (id) {
            return this.getUrl('storeManagers/' + id);
        }
        return this.getUrl('storeManagers');
    }

    public storeManagerAccountRestore() {
        return this.getUrl('storeManagers/restore');
    }

    public storeManagerAccountEmailExist(email: string) {
        return this.getUrl('storeManagers/emailExist?email=' + encodeURIComponent(email));
    }

    public loyaltyPrograms(id?: number) {
        if (id) {
            return this.getUrl(`loyaltyPrograms/${id}`);
        } else {
            return this.getUrl('loyaltyPrograms');
        }
    }

    public loyaltyProgramsThresholds() {
        return this.getUrl('loyaltyPrograms/Thresholds');
    }

    public inLoyaltyProgram(town: string) {
        return this.getUrl(`loyaltyPrograms/${encodeURIComponent(town)}/inProgram`);
    }

    public tapAndGoPlaces() {
        return this.getUrl(`OrderSettings`);
    }

    public tapAndGoPlace(id: number) {
        return this.getUrl(`OrderSettings/${id}`);
    }

    public generateMonitorKey() {
        return this.getUrl(`OrderSettings/generateMonitorKey`);
    }

    public categoryMappingExist() {
        return this.getUrl('products/categoryMapping/exist');
    }

    public categoryMappingImport() {
        return this.getUrl('products/categoryMapping/import');
    }

    public productsImport() {
        return this.getUrl('products/import');
    }

    public productsImportQueued() {
        return this.getUrl('products/import/queued');
    }
    public productsMetadata() {
        return this.getUrl('products/metadata');
    }
    public getInformationCards() {
        return this.getUrl('informationCards');
    }

    public searchInformationCards() {
        return this.getUrl('InformationCards/Find');
    }

    public getInformationCardImageUrl(id: string, width?: number, height?: number) {
        if (width && height) {
            return this.getCDNUrl('informationCards/images/' + id + '?width=' + width + '&height=' + height);
        } else {
            return this.getCDNUrl('informationCards/images/' + id);
        }
    }

    public informationCardImage(id?: string) {
        if (id) {
            return this.getCDNUrl('informationCards/image/' + id);
        } else {
            return this.getCDNUrl('informationCards/image');
        }
    }

    public informationCard(id?: string) {
        if (id) {
            return this.getUrl('informationCards/' + id);
        } else {
            return this.getUrl('informationCards');
        }
    }

    public archiveInformationCard(id: string) {
        return this.getUrl(`informationCards/${id}/archive`);
    }

    public restoreInformationCard(id: string) {
        return this.getUrl(`informationCards/${id}/restore`);
    }

    public informationCardLinkTypes() {
        return this.getUrl('informationCards/linkTypes');
    }

    public existInformationCards(state: number) {
        return this.getUrl(`informationCards/${state}/exist`);
    }

    public informationCardImageCopy() {
        return this.getUrl('informationCards/image/copy');
    }

    public storesCampaigns() {
        return this.getUrl('stores/campaigns');
    }

    public staffRatingSummary(isArchived: boolean) {
        return this.getUrl(`SalesAssistantsRating/Summary?isArchived=${isArchived}`);
    }

    public staffRatingSummaryByID(id: number) {
        return this.getUrl(`SalesAssistantsRating/${id}`);
    }

    public staffRatingData(offset: number, limit: number, sortColumn: string, sortOrder: number, isActive: boolean) {
        const url = `SalesAssistantsRating?offset=${offset}&limit=${limit}&sortColumn=${sortColumn}&sortOrder=${sortOrder}&isArchive=${!isActive}`;
        return this.getUrl(url);
    }

    public staffRatingDataByID(id: number, offset: number, limit: number, sortColumn: string, sortOrder: number, startDate: string, endDate: string) {
        let url = `SalesAssistantsRating/${id}/RatingHistory?offset=${offset}&limit=${limit}&sortColumn=${sortColumn}&sortOrder=${sortOrder}`;
        if (startDate) {
            url += `&startDate=${startDate}`;
        }
        if (endDate) {
            url += `&endDate=${endDate}`;
        }
        return this.getUrl(url);
    }

    public staffRatingSettings() {
        return this.getUrl('SalesAssistantsRating/RatingSettings');
    }

    public staffRatingSettingsByStaffID(id: number) {
        return this.getUrl(`SalesAssistantsRating/RatingSettings/${id}`);
    }

    public exportSalesAssistant() {
        return this.getUrl(`SalesAssistantsRating/export`);
    }

    public campaignAudience() {
        return this.getUrl('campaigns/audience');
    }

    public foodPreference() {
        return this.getUrl('Preferences/FoodPreferences');
    }

    public foodAllergens() {
        return this.getUrl('Preferences/Allergens');
    }

    public countryOrigins() {
        return this.getUrl('products/CountryOrigins');
    }

    public shopperStaffs() {
        return this.getUrl('ShopperStaffs');
    }

    public createStaffDiscount() {
        return this.getUrl('ShopperStaffs/Discount');
    }

    public editStaffDiscount(discountID: number) {
        return this.getUrl(`ShopperStaffs/Discount/${discountID}`);
    }

    public findStaff() {
        return this.getUrl('Shoppers/FindByEmail');
    }

    public transactionsHistorySummary() {
        return this.getUrl('ShopperStaffs/Transactions/Summary');
    }

    public allTransactionsHistory() {
        return this.getUrl('ShopperStaffs/Transactions');
    }

    public transactionHistory(transactionID: number) {
        return this.getUrl(`ShopperStaffs/Transaction/${transactionID}`);
    }

    public checkPassword() {
        return this.getUrl('Account');
    }

    public archiveStaff(discountID: number) {
        return this.getUrl(`/ShopperStaffs/Discount/${discountID}`);
    }

    public companyInfoUrl() {
        return this.getUrl(`Profile/CompanyInformation`);
    }

    public tablesEnabled(shopID: number) {
        return this.getUrl(`stores/${shopID}/Tables/Settings`);
    }

    public setTablesEnabled(shopID: number) {
        return this.getUrl(`stores/${shopID}/Tables/Enable`);
    }

    public setTablesMandatory(shopID: number) {
        return this.getUrl(`stores/${shopID}/Tables/Mandatory`);
    }

    public tableExist(shopID: number, name: string) {
        return this.getUrl(`stores/${shopID}/Tables/Exists?name=${name}`);
    }

    public tables(shopID: number) {
        return this.getUrl(`stores/${shopID}/Tables`);
    }

    public table(shopID: number, tableID: number) {
        return this.getUrl(`stores/${shopID}/Tables/${tableID}`);
    }

    public setProfileImage() {
        return this.getUrl('Profile/Logo');
    }

    public getProfileImage(imageId: number, width?: number, height?: number) {
        if (width && height) {
            return this.getCDNUrl('profile/logo/' + imageId + '?width=' + width + '&height=' + height);
        } else {
            return this.getCDNUrl('profile/logo/' + imageId);
        }
    }

    public deleteProfileImage(imageId: string) {
        return this.getUrl(`Profile/Logo/${imageId}`);
    }

    public retailerAdvertsDefault() {
        return this.getUrl('RetailerAdverts/Default');
    }

    public retailerAdvertsImage(advertImageID: number, width?: number, height?: number, ) {
        let url = `RetailerAdverts/Image/${advertImageID}`;
        if (width && height) {
            url += `/thumbnail?width=${width}&height=${height}`;
        }
        return this.getCDNUrl(url);
    }

    public addRetailerAdvertsImage() {
        return this.getUrl('RetailerAdverts/Image');
    }

    public retailerAdverts(advertID?: number) {
        if (advertID) {
            return this.getUrl( `RetailerAdverts/${advertID}`);
        } else {
            return this.getUrl('RetailerAdverts');
        }
    }

    public getRetailerAdvertsImageUrl(advertImageID: number, width?: number, height?: number, ) {
        return this.retailerAdvertsImage(advertImageID, width, height);
    }

    public getIngredients() {
        return this.getUrl('Ingredients');
    }

    public getIngredient(id: string) {
        return this.getUrl(`Ingredients/${id}`);
    }

    public getCheckIngredients() {
        return this.getUrl('Ingredients/CheckTitle');
    }

    public archiveIngredient(id: string) {
        return this.getUrl(`Ingredients/${id}/Archive`);
    }

    public restoreIngredient(id: string) {
        return this.getUrl(`Ingredients/${id}/Restore`);
    }

    // ingredients
    public ingredients(id?: string) {
        return id ? this.getUrl(`ingredients/${id}`) : this.getUrl('ingredients');
    }

    // vendors
    public getVendors() {
        return this.getUrl('Vendors');
    }

    public getVendor(id: number) {
        return this.getUrl(`Vendors/${id}`);
    }

    public archiveVendor(id: number) {
        return this.getUrl(`Vendors/${id}/Archive`);
    }

    public restoreVendors(id: number) {
        return this.getUrl(`Vendors/${id}/Restore`);
    }

    public createVendorImage() {
        return this.getUrl('vendors/image');
    }

    public getVendorImage(id: string): string {
        return this.getCDNUrl(`vendors/image/${id}`);
    }

    public getServices() {
        return this.getUrl('Services/fetch');
    }

    public getService(id: string) {
        return this.getUrl(`Services/${id}`);
    }

    public getCheckServices() {
        return this.getUrl('Services/CheckTitle');
    }

    public archiveService(id: string) {
        return this.getUrl(`Services/${id}/Archive`);
    }

    public restoreService(id: string) {
        return this.getUrl(`Services/${id}/Restore`);
    }

    public createService() {
        return this.getUrl('Service');
    }

    // vouchers

    public vouchers() {
        return this.getUrl('Vouchers');
    }

    public getVoucherById(id: number) {
        return this.getUrl(`Vouchers/${id}`);
    }

    public publishVoucher() {
        return this.getUrl('Vouchers/Publish');
    }

    // publisher settings
    public accessSettings(): string {
        return this.getUrl('DppAccessSettings');
    }

    public allStores(): string {
        return this.getUrl('Stores/GetAll');
    }

    public savePublisher(id: number): string {
        return this.getUrl(`Stores/${id}/Publisher`);
    }

    // reading locations

    public readingLocationsList() {
        return this.getUrl('ReadingLocations/Fetch');
    }

    public readingLocation() {
        return this.getUrl('/ReadingLocations');
    }

    public readingLocationById(readingLocationID: string) {
        return this.getUrl(`/ReadingLocations/${readingLocationID}`);
    }

    public readingLocationArchive(readingLocationID: string) {
        return this.getUrl(`ReadingLocations/${readingLocationID}/Archive`);
    }

    public readingLocationRestore(readingLocationID: string) {
        return this.getUrl(`ReadingLocations/${readingLocationID}/Restore`);
    }

    public readingLocationDeepLink(readingLocationID: string) {
        return this.getUrl(`ReadingLocations/${readingLocationID}/Deeplink`);
    }

    public readingLocationCheckName(readingLocationName: string) {
        return this.getUrl(`/ReadingLocations/CheckName?name=${readingLocationName}`);
    }

    public variationsReport(): string {
        return this.getUrl('DppAnalytics/Variations');
    }

    public bundles(): string {
        return this.getUrl('Bundles');
    }

    public bundleItem(bundleId: number): string {
        return this.getUrl(`Bundles/${bundleId}`);
    }

    public storeBundleImage(): string {
        return this.getUrl('Bundles/Image');
    }

    public bundleImage(id: number, width?: number, height?: number): string {
        let url = `Bundles/Image/${id}`;
        if (width && height) {
            url += `?width=${width}&height=${height}`;
        }
        return this.getCDNUrl(url);
    }

    public serviceImage(imageId: string, width?: number, height?: number): string {
        let url = `Services/Image/${imageId}`;
        if (width && height) {
            url += `?width=${width}&height=${height}`;
        }
        return this.getCDNUrl(url);
    }

    public uploadServiceImage(): string {
        return this.getUrl(`Services/Image`);
    }

    public printerSettings(): string {
        return this.getUrl('Printing/PrinterSettings');
    }

    public printerSettingsByPrinter(): string {
        return this.getUrl('Printing/PrinterSettings/ByPrinter');
    }

    public testPrinting(): string {
        return this.getUrl('Printing/TestPrint');
    }

    public categoriesForVouchers(): string {
        return this.getUrl('ClassificationCategories/ForVouchers');
    }

    public getVoucherRestrictedCategories(): string {
        return this.getUrl('Vouchers/RestrictedCategories');
    }
}

angular
    .module('naut')
    .service('retailerService', RetailerService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/api/retailer.service.ts